/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      taxId: "",
      typeDocuments: "",
      numberDocuments: "",
      ownerName: "",
      accountNumber: "",
      accountClosingDate: "",
      typeCustomers: "",
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        taxId: "",
        typeDocuments: "",
        numberDocuments: "",
        ownerName: "",
        accountNumber: "",
        accountOpeningDate: "",
        accountClosingDate: "",
        typeCustomers: "",
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" style={{ textAlign: "center", minWidth: 10 }}>
                STT
              </Td>
              <Td style={{ textAlign: "center", minWidth: 200 }}>Mã số thuế</Td>
              <Td style={{ textAlign: "center", minWidth: 200 }}>Loại giấy tờ</Td>
              <Td style={{ textAlign: "center", minWidth: 200 }}>Số giấy tờ</Td>
              <Td style={{ textAlign: "center", minWidth: 200 }}>Tên chủ tài khoản</Td>
              <Td style={{ textAlign: "center", minWidth: 200 }}>Số hiệu tài khoản</Td>
              <Td style={{ textAlign: "center" }}>Ngày mở tài khoản</Td>
              <Td style={{ textAlign: "center" }}>Ngày đóng tài khoản</Td>
              <Td style={{ textAlign: "center", minWidth: 200 }}>Loại khách hàng</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}></Td>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6)</Td>
              <Td style={{ textAlign: "center" }}>(7)</Td>
              <Td style={{ textAlign: "center" }}>(8)</Td>
              <Td style={{ textAlign: "center" }}>(9)</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxId"
                    value={item.taxId}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "typeDocuments", e.target.value)}
                  >
                    <option value="value1">Mã số doanh nghiệp</option>
                    <option value="value2">
                      Số của giấy tờ chứng minh việc tổ chức được thành lập theo quy định của pháp
                      luật
                    </option>
                    <option value="value3">CMT</option>
                    <option value="value4">Thẻ căn cước</option>
                    <option value="value5">Hộ chiếu</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="numberDocuments"
                    value={item.numberDocuments}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="ownerName"
                    value={item.ownerName}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="accountNumber"
                    value={item.accountNumber}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <DatePicker
                    style={{
                      fontSize: 13,
                      color: "#495057",
                      border: "0.0625rem solid #d2d6da",
                      background: "#fff",
                      padding: "0.5rem 0.75rem",
                      width: "100%",
                      borderRadius: "0.5rem",
                    }}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="accountOpeningDate"
                    value={item.accountOpeningDate}
                    onChange={(date) => handleChangeDate(date, item.id)}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <DatePicker
                    style={{
                      fontSize: 13,
                      color: "#495057",
                      border: "0.0625rem solid #d2d6da",
                      background: "#fff",
                      padding: "0.5rem 0.75rem",
                      width: "100%",
                      borderRadius: "0.5rem",
                    }}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="accountClosingDate"
                    value={item.accountClosingDate}
                    onChange={(date) => handleChangeDate(date, item.id)}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "status", e.target.value)}
                  >
                    <option value="value1">Tổ chức</option>
                    <option value="value2">Cá nhân</option>
                  </select>
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
